import {
  MembershipStatusEnum,
  RoleEnum,
  UserNextStepEnum,
} from '@sr-sdks/api-sdk-axios';

export const ALL_WORKSPACES = '*';

export const SUPPORT_EMAIL = 'support@screenrights.org';
export const INDUSTRY_EMAIL = 'industry@screenrights.org';

export const MEMBERSHIP_AGREEMENT_URL =
  'https://www.screenrights.org/membership-agreement-terms-conditions/';

export const AccessLevelMap: Record<RoleEnum, string> = {
  'authenticated-user': 'Authenticated User',
  'customer-support-supervisor': 'Service Supervisor',
  'customer-support-user': 'Service Specialist',
  'payment-authoriser': 'Finance Supervisor',
  'payment-preparer': 'Finance Specialist',
  'system-admin': 'System Admin',
  'system-process': 'System Process',
  'workspace-admin': 'Admin',
  'workspace-owner': 'Owner',
  'workspace-user': 'Standard',
};

export const PAYOUT_STATUS = 'status';

export const PAYOUT_SEARCH = 'searchValue';

export const CLIENT_SEARCH = 'clientSearch';

export const ACCESS_DENIED = 'deny';
export const ACCESS_ALLOWED = 'allow';

export const SEND_INVITE_SUCCESS_MESSAGE = 'Your invitation(s) have been sent.';
export const SEND_INVITE_FAILED_MESSAGE = 'Failed to send invitation(s).';
export const STAFF_ACCESS_UPDATED_SUCCESS_MESSAGE =
  'Your staff access have been updated.';

export const BENEFICIARY_TYPES = {
  NON_PARTY: 'nonParty',
  PARTY: 'party',
};

export const MEMBERSHIP_MAX_COMMENT_LENGTH = 1000;

export const MEMBERSHIP_ACTIONABLE_STATUSES: Partial<MembershipStatusEnum>[] = [
  MembershipStatusEnum.InReview,
  MembershipStatusEnum.PendingApproval,
  MembershipStatusEnum.Rejected,
  MembershipStatusEnum.AwaitingUpdate,
  MembershipStatusEnum.NonMember,
];

// Invitation flow button text mapping
export const getInvitationButtonText = (
  nextStep?: UserNextStepEnum | string,
): string => {
  switch (nextStep) {
    case UserNextStepEnum.ChoosePassword:
      return 'Set Password';
    case UserNextStepEnum.Login:
      return 'Login';
    case UserNextStepEnum.Signup:
      return 'Sign Up';
    default:
      return 'Sign Up / Login';
  }
};
